import { render, staticRenderFns } from "./edit-details.vue?vue&type=template&id=2d825332&scoped=true&"
import script from "./edit-details.vue?vue&type=script&lang=js&"
export * from "./edit-details.vue?vue&type=script&lang=js&"
import style0 from "./edit-details.vue?vue&type=style&index=0&id=2d825332&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d825332",
  null
  
)

export default component.exports